// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.close-button {
  color: black;
  border: 1px solid black;
  background-color: white;
  gap: 24px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ECF0F5;
  gap: 24px;
}

.p-button.button-sm {
  font-size: 12px;
  padding: 10px 12px;
  width: auto;
  height: 32px;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.gc-agency-name {
  color: #2d388b;
}

.eSockFiles table {
  padding: 0;
}
.eSockFiles table th {
  background-color: #f6f8ff;
  padding: 10px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 16px;
  color: #1F2937;
}
.eSockFiles table td {
  border-bottom: 1px solid #e9ecef;
  text-align: left;
  padding: 10px 20px;
  overflow-wrap: anywhere;
  font-size: 14px;
  color: #1F2937;
}
.eSockFiles table tr:last-child td {
  border: none;
}

.w-165 {
  width: 165px !important;
}

.align-expand-text {
  text-align: center;
  color: #2d388b;
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
}

.multi-entry-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.multi-entry-row .flex-grow-1 {
  flex: 1;
  min-width: 0;
}

.btn-remove-entry {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  flex-shrink: 0;
}

.btn-add-entry {
  padding: 4px 0 !important;
  font-size: 13px;
  height: auto !important;
  width: auto !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  color: #6B7280 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/esoc-upload/esoc-upload.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AACN;AACI;EACE,yBAAA;AACN;AAAM;EACE,0BAAA;AAER;;AAEE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AACE;EACE,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAEJ;;AAAE;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AAGJ;;AADE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAIJ;;AAFE;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAKJ;;AAHE;EACE,cAAA;AAMJ;;AAFI;EACE,UAAA;AAKN;AAJM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAMR;AAJM;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAMR;AAFU;EACE,YAAA;AAIZ;;AAGE;EACE,uBAAA;AAAJ;;AAGE;EACE,kBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;AAAJ;;AAGE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAJ;AAEI;EACE,OAAA;EACA,YAAA;AAAN;;AAIE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;AADJ;;AAIE;EACE,yBAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;AADJ","sourcesContent":[".dropzone {\n    position: relative;\n    height: 200px;\n    width: 100%;\n    border: 2px dashed #D1D5DB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    // background: url(../../assets/images/fileupload.svg) no-repeat center center;\n    input{\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      opacity: 0;\n    }\n    label{\n      color: #1F2937 !important;\n      u{\n        text-decoration: underline;\n      }\n    }\n  }\n  .fileupload-info{\n    background:#f6f8ff;\n    padding: 15px;\n    border-radius: 6px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  .close-button {\n    color: black;\n    border: 1px solid black;\n    background-color: white;\n    gap: 24px;\n  }\n  .button-container {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 20px;\n    border-top: 1px solid #ECF0F5;\n    gap: 24px;\n  }\n  .p-button.button-sm{\n    font-size: 12px;\n    padding: 10px 12px;\n    width: auto;\n    height: 32px;\n  }\n  .fileupload-text{\n    display: block;\n    width: 85%;\n    word-wrap: break-word;\n  }\n  .gc-agency-name{\n    color: #2d388b;\n  }\n\n  .eSockFiles{\n    table{\n      padding: 0;\n      th{\n        background-color: #f6f8ff;\n        padding: 10px 20px;\n        text-align: left;\n        font-weight: 600;\n        font-size: 16px;\n        color: #1F2937;\n      }\n      td{\n        border-bottom: 1px solid #e9ecef;\n        text-align: left;\n        padding: 10px 20px;\n        overflow-wrap: anywhere;\n        font-size: 14px;\n        color: #1F2937;\n      }\n      tr{\n        &:last-child{\n          td{\n            border: none;\n          }\n        }\n      }\n    }\n  }\n\n  .w-165 {\n    width: 165px !important;\n  }\n\n  .align-expand-text {\n    text-align: center;\n    color: #2d388b;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 14px;\n  }\n\n  .multi-entry-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 8px;\n\n    .flex-grow-1 {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .btn-remove-entry {\n    width: 32px !important;\n    height: 32px !important;\n    padding: 0 !important;\n    flex-shrink: 0;\n  }\n\n  .btn-add-entry {\n    padding: 4px 0 !important;\n    font-size: 13px;\n    height: auto !important;\n    width: auto !important;\n    background: none !important;\n    border: none !important;\n    box-shadow: none !important;\n    color: #6B7280 !important;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
